import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'intToRes'
})
export class IntToResPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return `${value}px`;
  }

}
